module.exports = __webpack_public_path__ + "media/images/bookings/childcare/supervisor@2x-36adb4452a6e15de2f6635628ca64a48.jpg";